module.exports = __webpack_public_path__ + "assets/1f8ce126a5a1585a2fdcb96cb857cf3e.png";